import * as angular from 'angular';
import * as _ from 'lodash';
import ReportScheduleResource from '../models/report-schedule-resource';
import ResourceService from '../services/resource.service';

export default class ReportScheduleService extends ResourceService<ReportScheduleResource> {
  constructor(private BackendService: any) {
    super(BackendService, ReportScheduleResource);
  }
}

angular
  .module('ciApp.services')
  .service('ReportScheduleService', ['BackendService', ReportScheduleService]);



// WEBPACK FOOTER //
// ./common/services/report-schedule.service.ts